import React from 'react';
import { useTheme } from '@mui/material/styles/';
import { props, defaultProps } from './entitiesIconsProps';

const NetworkBoldIcon = ({ width, height }) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
      width={width}
      height={height}
    >
      <path
        d="M320 32C346.5 32 368 53.49 368 80V144C368 170.5 346.5 192 320 192H312V232H464C494.9 232 520 257.1 520 288V320H528C554.5 320 576 341.5 576 368V432C576 458.5 554.5 480 528 480H464C437.5 480 416 458.5 416 432V368C416 341.5 437.5 320 464 320H472V288C472 283.6 468.4 280 464 280H312V320H320C346.5 320 368 341.5 368 368V432C368 458.5 346.5 480 320 480H256C229.5 480 208 458.5 208 432V368C208 341.5 229.5 320 256 320H264V280H112C107.6 280 104 283.6 104 288V320H112C138.5 320 160 341.5 160 368V432C160 458.5 138.5 480 112 480H48C21.49 480 0 458.5 0 432V368C0 341.5 21.49 320 48 320H56V288C56 257.1 81.07 232 112 232H264V192H256C229.5 192 208 170.5 208 144V80C208 53.49 229.5 32 256 32H320zM320 80H256V144H320V80zM48 432H112V368H48V432zM256 432H320V368H256V432zM464 432H528V368H464V432z"
        fill={theme.palette.secondary.main}
      />
    </svg>
  );
};

NetworkBoldIcon.propTypes = props;

NetworkBoldIcon.defaultProps = defaultProps;

export default NetworkBoldIcon;
